const BaseEntry = require('./BaseEntry');
const getConstants = require('../../../utils/getConstants');
const constants = getConstants();
const { answerStates } = constants;

class ToDoEntry extends BaseEntry {
   constructor(aggregateRoot, componentData, items, entries, ruleEvaluator) {
      super(aggregateRoot, componentData, items, entries, ruleEvaluator);
   }

   markComplete({ actionedOn, geoLat, geoLong, geoTimeStamp }) {
      const item = this.item;

      const newItemState = item.state | answerStates.ANSWERED;

      const noResponse = item.response ? item.response.no : 1;

      const p = {
         idItem: this.idItem,
         state: newItemState,
         actionedOn,
         noResponse: noResponse,
         noSubmissionItem: item.no,
         noSubmission: this._aggregateRoot.getSubmissionNo(),
         geoLat,
         geoLong,
         geoTimeStamp
      };

      this.apply('TODO_MARKED_AS_COMPLETE', p);

      item.response = item.response || {};
      item.response.no = noResponse;
      item.response.val = true;
      item.response.actionedOn = actionedOn;
      item.state = newItemState;
      item.geoLat = geoLat;
      item.geoLong = geoLong;
      item.geoTimeStamp = geoTimeStamp;
   }

   markIncomplete({ actionedOn }) {
      const item = this.item;

      const newItemState = item.state | answerStates.ANSWERED;

      const noResponse = item.response ? item.response.no : 1;

      const p = {
         idItem: this.idItem,
         state: newItemState,
         actionedOn,
         noResponse: noResponse,
         noSubmissionItem: item.no,
         noSubmission: this._aggregateRoot.getSubmissionNo(),
         geoLat: null,
         geoLong: null,
         geoTimeStamp: null
      };

      this.apply('TODO_MARKED_AS_INCOMPLETE', p);

      item.response = item.response || {};
      item.response.no = noResponse;
      item.response.val = false;
      item.response.actionedOn = actionedOn;
      item.state = newItemState;
      item.geoLat = null;
      item.geoLong = null;
      item.geoTimeStamp = null;
   }

   lock() {
      const item = this.item;
      const { state } = item;
      item.state = state | answerStates.LOCKED;
   }

   unlock() {
      const item = this.item;
      const { state } = item;
      item.state = state & ~answerStates.LOCKED;
   }

   validate() {
      const item = this.item;
      const { state } = item;

      const isSkipped = (state & answerStates.SKIPPED) == answerStates.SKIPPED;
      const isValid = !!item.response.val || isSkipped;

      return this.setCurrentValidity(isValid);
   }

   getFriendlyValue() {
      const item = this.item;
      let value = item.response && item.response.val !== undefined ? item.response.val : false;

      return value ? 'Done' : 'Not done';
   }
}

module.exports = ToDoEntry;
